import { useTranslation } from '../i18n'
import { useTheme } from '../hooks/useTheme'
import { getSectionCardStyle } from '../utils/themeStyles'

export default function Reports() {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <div className="p-5">
      <header className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: theme.text.primary }}>
          {t.reports.title}
        </h1>
        <p className="text-sm" style={{ color: theme.text.muted }}>
          {t.reports.subtitle}
        </p>
      </header>

      <div className="rounded-xl p-6 text-center" style={getSectionCardStyle(theme)}>
        <div className="text-5xl mb-4">📊</div>
        <h3 className="text-lg font-semibold mb-2" style={{ color: theme.text.primary }}>
          {t.reports.comingSoon.title}
        </h3>
        <p className="text-sm leading-relaxed" style={{ color: theme.text.muted }}>
          {t.reports.comingSoon.description}
        </p>
      </div>
    </div>
  )
}
